import memoizeOne from 'memoize-one';

import { Channel, ChannelAsset } from '../types';

type TryCreateChannelArgs = {
  channelAssetsMap: Map<number, ChannelAsset>;
  entitledChannels: Set<number>;
  id: number;
};

export function tryCreateChannel({
  channelAssetsMap,
  entitledChannels,
  id,
}: TryCreateChannelArgs): Channel | undefined {
  const asset = channelAssetsMap.get(id);

  if (!asset) {
    return;
  }

  const isEntitled = entitledChannels.has(id);

  if (asset.channelNumber && (isEntitled || asset.representPackage)) {
    return {
      ...asset,
      isEntitled,
      isFavorite: false,
    };
  }
}

export const createNewChannelsPclDictionary = memoizeOne(
  (channels: Map<number, ChannelAsset>, pclDictionary: Map<number, number>, highestChannelNumber: number) => {
    const newChannelsPClDictionary = new Map();

    for (const [channelId] of channels) {
      if (!pclDictionary.has(channelId)) {
        const size = newChannelsPClDictionary.size;

        newChannelsPClDictionary.set(channelId, highestChannelNumber + size + 1);
      }
    }

    return newChannelsPClDictionary;
  },
);
